import { ReactNode } from "react";
import { ActionBars as ActionBarsPrimitive, ActionBarItem } from "capitalrx-components-2.0/lib/layout";
import { useContentChannel } from "./ContentChannel";
import { BreadcrumbItems } from "./Breadcrumb";
import { useLayout } from "../ContentLayout";

/**
 * Shell adapter for ActionBars that handles channel subscription and passes data to the pure component.
 * This component wires up shell-specific concerns (channels, layout, breadcrumbs) and delegates
 * rendering to the pure ActionBars component from layout.
 */
export const ActionBars = (): ReactNode => {
  const actionBarSubscriptions = useContentChannel(null, "app-action-bars");
  const layoutType = useLayout();

  /* useContentChannel already narrows to component subscriptions, so map directly.
     Combine the module id with the subscription index so a module publishing more
     than one action bar still yields unique React keys. */
  const actions: ReadonlyArray<ActionBarItem> = actionBarSubscriptions.map((subscription, index) => ({
    id: `${subscription.module.id}-${index}`,
    content: <subscription.component />,
  }));

  return (
    <ActionBarsPrimitive
      actions={actions}
      layoutType={layoutType}
      breadcrumbs={<BreadcrumbItems />}
    />
  );
};
